export const getFilenameFromContentDisposition = (
  contentDisposition: string
) => {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);
  if (matches && matches[1]) {
    return matches[1].replace(/['"]/g, "");
  }

  return undefined;
};
